/**
 * Location pathnames can carry a trailing slash that the routes themselves do not:
 * static directories under `public` (for example `public/legal`) make the dev server
 * redirect `/legal` to `/legal/`, and users can type one by hand. React Router matches
 * those paths, so route comparisons have to tolerate them as well.
 */
export const normalizePathname = (pathname: string) => {
  const normalized = pathname.replace(/\/+$/, '');
  return normalized.length > 0 ? normalized : '/';
};

export const isRouteActive = (pathname: string, route: string) =>
  normalizePathname(pathname) === normalizePathname(route);
